import { render } from "./Delete.vue?vue&type=template&id=27cfa62b"
import script from "./Delete.vue?vue&type=script&lang=js"
export * from "./Delete.vue?vue&type=script&lang=js"
script.render = render

export default script